import React,{useEffect,useState,useContext} from 'react'
import {TextField,Grid, Box,Button, OutlinedInput,IconButton,InputAdornment,FormHelperText} from "@mui/material"
import { useForm, Controller } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import { FreeRideSixSchema } from '../../Utils/Validations'
import {Visibility,VisibilityOff} from '@mui/icons-material'
import { UserContext } from 'Hooks/UserContext'

const RideFormSeven = ({ handleBack, handleComplete, freeRideData, setFreeRideData }) => {
    const [showPassword,setShowPassword] = useState(false)
    const {checkPasswordStrength,passwordStatus} = useContext(UserContext)
  const { handleSubmit, control, formState: { errors }, setValue } = useForm({
    resolver: yupResolver(FreeRideSixSchema)
  })
  useEffect(() => {
    setValue("password", freeRideData.password || "")
    setValue("cPassword", freeRideData.password || "")
  }, [])
  const onSubmit = (data) => {
    console.log(data)
    setFreeRideData((prev) => ({ ...prev, password: data.password }))
    handleComplete()
  }

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <div>
        
        <Grid container  style={{justifyContent:"center",marginTop:20}} >
            <Grid sm={6} xs={12} sx={{textAlign:"left",paddingRight:{sm:1,xs:0}}} >
            <Controller
            control={control}
            name="password"
            rules={{ required: true }}
            render={({ field:{onChange,value} }) => (
              <>
               <label>Password</label>
                <OutlinedInput 
                fullWidth 
                placeholder='Password' 
                 onChange={(e)=>{onChange(e);checkPasswordStrength(e.target.value)}}
                 error={errors.password} 
                 helperText={errors?.password?.message} 
                 type={showPassword ? 'text' : 'password'}
                 
                    endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                            size="large"
                          >
                            {showPassword ? <Visibility sx={{color:"#FFF"}} /> : <VisibilityOff sx={{color:"#FFF"}} />}
                          </IconButton>
                        </InputAdornment>
                      
                 }
                 />
                 <Box sx={{display:"flex",justifyContent:"space-between"}} >
                 <FormHelperText sx={{color:"red"}} >{errors?.password?.message}</FormHelperText>
                 <FormHelperText sx={{color:passwordStatus==="Weak"?"red":passwordStatus==="Good"?"yellow":"#97c11e"}}  >{passwordStatus}</FormHelperText>
                 </Box>
                 
              </>
            )}
          />
               
       
        
        </Grid>
        <Grid sm={6} xs={12} sx={{textAlign:"left",paddingLeft:{sm:1,xs:0},marginTop:{sm:0,xs:2}}}>
        <Controller
            control={control}
            name="cPassword"
            rules={{ required: true }}
            render={({ field }) => (
              <>
                <label> Confirm Password</label>
                <OutlinedInput 
                fullWidth 
                placeholder='Confirm Password' 
                 {...field} 
                 error={errors.cPassword} 
                 helperText={errors?.cPassword?.message} 
                 type={showPassword ? 'text' : 'password'}
                    endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                            size="large"
                          >
                            {showPassword ? <Visibility sx={{color:"#FFF"}} /> : <VisibilityOff sx={{color:"#FFF"}} />}
                          </IconButton>
                        </InputAdornment>
                      
                 }
                 />
                 <FormHelperText sx={{color:"red"}} >{errors?.cPassword?.message}</FormHelperText>
              </>
            )}
          />
       
        
        </Grid>
        </Grid>
        <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
        <Button
          color="inherit"
          // disabled={activeStep === 0}
          onClick={handleBack}
          sx={{minWidth:"10%", border: "none", color: "#FFF", bgcolor: "#97c11e", '&:hover': { bgcolor: "#021b38", border: "none" } }}
          variant="contained"
        >
          Back
        </Button>
        <Box sx={{ flex: '1 1 auto' }} />


        <Button color="inherit" variant="contained" sx={{minWidth:"10%", border: "none", color: "#FFF", bgcolor: "#97c11e", '&:hover': { bgcolor: "#021b38", border: "none" } }} onClick={handleSubmit(onSubmit)}>


          Next
        </Button>

      </Box>
    </div>
  )
}

export default RideFormSeven